import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { AddressData } from '../../../../../../assets/js/com/ts_api_client';

@Component({
    selector: 'bdo-address-summary',
    templateUrl: './address-summary.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AddressSummaryComponent {
  @Input() addressData: AddressData;

}
